import React, { useEffect, useState } from 'react';

import statusService from '../../service/status.service';
import addNotification from '../../utils/addNotification';
import { NotificationType } from '../../config';
import { ColorPicker } from '../../config/ColorPicker';
import { dataGridColumns } from '../../utils/helper';

import AddDialog from './AddDialog';
import {
  ButtonUI,
  DataGridUI,
  DataGridIdentifiers,
  DeleteDialogUI,
  ColorPickerUI,
  SwitchUI,
  OrderArrowsUI,
  CheckboxUI,
} from '../Interface';

const FormTable = (props) => {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [removeId, setRemoveId] = useState(null);
  const [addModalShow, setAddModalShow] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    const defVal = [props.selectedValues?.defaultValue ?? undefined];
    setSelectedRows(defVal);
    props.setRefetchTable(true);
  }, [props.selectedValues]);

  const removeStatusItem = async (itemId) => {
    statusService
      .deleteStatusItem(itemId)
      .then(() => {
        addNotification({
          content: 'Sikeres mentés!',
          type: NotificationType.WARNING,
        });
        props.setstatusList(props.statusList.filter((item) => item.itemId !== itemId));
        props.setRefetchTable(true);
      })
      .finally(() => {
        setShowDeleteDialog(false);
      });
  };

  const deleteIcon = (props, params) => {
    return (
      <div
        disabled={props.disabled}
        className={props.disabled ? 'hidden' : 'block cursor-pointer'}
        onClick={(e) => {
          e.stopPropagation();
          setRemoveId(params.row.itemId);
          setShowDeleteDialog(true);
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          className="w-[20px] h-[20px]"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line> <line x1="6" y1="6" x2="18" y2="18"></line>{' '}
        </svg>
      </div>
    );
  };

  const addDefaultValue = async (itemId) => {
    if (itemId !== null) {
      statusService.updateDefaultValue(props.statusId, itemId).then(() => {
        addNotification({
          content: 'Alapértelmezett érték frissítve!',
          type: NotificationType.SUCCESS,
        });
      });
    }
  };

  const addOnKanban = async (itemId, onKanban) => {
    statusService.updateOnKanban(itemId, onKanban).then(() => {
      addNotification({
        content: 'Sikeres hozzáadás!',
        type: NotificationType.SUCCESS,
      });
      const updatedStatusList = props.statusList.map((item) =>
        item.itemId === itemId ? { ...item, onKanban: onKanban } : item
      );
      props.setstatusList(updatedStatusList);
      props.setRefetchTable(true);
    });
  };

  const updateFinalStatus = async (itemId, final) => {
    const body = {
      statusId: props.statusId,
      itemId,
      final,
    };
    statusService.updateFinalStatus(body).then(() => {
      addNotification({
        content: 'Sikeres módosítás!',
        type: NotificationType.SUCCESS,
      });
      const updatedStatusList = props.statusList.map((item) => {
        if (item.itemId === itemId) {
          return { ...item, final: final };
        }
        if (final && item.final) {
          return { ...item, final: false };
        }

        return item;
      });

      props.setstatusList(updatedStatusList);
      props.setRefetchTable(true);
    });
  };

  const orderItem = (itemId, newOrder) => {
    statusService.orderStatusItem(itemId, { newOrder }).then(() => {
      props.setRefetchTable(true);
    });
  };

  const handleOrderChange = (itemId, currentOrder, direction) => {
    const newOrder = direction === 'up' ? currentOrder - 1 : currentOrder + 1;

    const updatedList = props.statusList
      .map((item) => {
        if (item.itemId === itemId) {
          return { ...item, visOrder: newOrder };
        } else if (item.visOrder === newOrder) {
          return { ...item, visOrder: currentOrder };
        }
        return item;
      })
      .sort((a, b) => a.visOrder - b.visOrder);
    props.setstatusList(updatedList);

    orderItem(itemId, newOrder);
  };

  const columns = dataGridColumns([
    {
      field: 'itemId',
      headerName: 'Azonosító',
      flex: 0,
    },
    {
      field: 'itemName',
      headerName: 'Megnevezés',
      flex: 1,
      valueGetter: (params) => {
        return params.value ? params.value : 'Nincs adat.';
      },
    },
    {
      field: 'color',
      headerName: 'Beállított szín',
      flex: 1,
      renderCell: (params) => {
        const colorItem = ColorPicker.find((col) => col.colorName === params.value);
        return <ColorPickerUI disabled color={colorItem ? colorItem.colorCode : '#FFFFFF'} />;
      },
    },
    {
      field: 'preparedness',
      headerName: 'Készültség (%)',
      flex: 1,
    },
    {
      field: 'kanban',
      headerName: 'Kanban',
      flex: 0,
      renderCell: (params) => {
        return (
          <SwitchUI
            disabled={props.viewField}
            onClick={(e) => addOnKanban(params.row.itemId, e.target.checked)}
            checked={params.row.onKanban}
          />
        );
      },
    },
    {
      field: 'final',
      headerName: 'Kész',
      flex: 0,
      renderCell: (params) => {
        return (
          <CheckboxUI
            disabled={props.viewField}
            onChange={(e) => updateFinalStatus(params.row.itemId, e.target.checked)}
            checked={params.row.final}
          />
        );
      },
    },
    {
      field: 'visOrder',
      headerName: 'Sorrend',
      flex: 0,
      renderCell: (params) => {
        const handleUpClick = () => handleOrderChange(params.row.itemId, params.row.visOrder, 'up');
        const handleDownClick = () => handleOrderChange(params.row.itemId, params.row.visOrder, 'down');
        return <OrderArrowsUI onUpClick={handleUpClick} onDownClick={handleDownClick} disabled={props.viewField} />;
      },
    },
    {
      field: 'removeTag',
      headerName: '',
      flex: 0.4,
      renderCell: (params) => {
        return deleteIcon(props, params);
      },
    },
  ]);

  const handleCellClick = (param, event) => {
    if (
      param.field === 'color' ||
      param.field === 'itemId' ||
      param.field === 'itemName' ||
      param.field === 'preparedness'
    ) {
      if (!props.viewField) {
        setSelectedItem(param.row);
        setAddModalShow(true);
      }
    } else {
      return;
    }
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">Elemek</h1>
          <p className="mt-2 text-sm text-gray-700">További elemek hozzáadása.</p>
        </div>
        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <ButtonUI
            text="Hozzáadás"
            type="button"
            disabled={props.disabled}
            onClick={() => {
              setAddModalShow(true);
            }}
            className="bg-success block rounded-md px-3 disabled:cursor-not-allowed disabled:opacity-50 py-2 text-center text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          ></ButtonUI>
        </div>
      </div>
      <div className="mt-8 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle ">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
              <DataGridUI
                datagridIdentifier={DataGridIdentifiers.StatusFormTable}
                sx={{
                  height: props.dialog ? 350 : 440,
                  width: '100%',
                  '& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer': {
                    display: 'none',
                  },
                  '& .MuiDataGrid-columnHeaderDraggableContainer': {
                    backgroundColor: '#CEDFE8',
                  },
                }}
                columns={columns}
                rows={props.statusList}
                getRowId={(row) => row.itemId}
                onRowSelectionModelChange={(newRowSelectionModel) => {
                  if (newRowSelectionModel.length > 0) {
                    setSelectedRows([newRowSelectionModel[newRowSelectionModel.length - 1]]);
                    addDefaultValue(newRowSelectionModel[newRowSelectionModel.length - 1]);
                  } else {
                    setSelectedRows([]);
                    addDefaultValue(null);
                  }
                }}
                selectedRows={selectedRows}
                checkboxSelection
                isRowSelectable={(params) => !props.viewField}
                rowSelectionModel={selectedRows}
                disableRowSelectionOnClick={true}
                onCellClick={handleCellClick}
              />
            </div>
          </div>
        </div>
      </div>
      <DeleteDialogUI
        show={showDeleteDialog}
        onHide={() => setShowDeleteDialog(false)}
        handleRemoveElement={() => removeStatusItem(removeId)}
      />

      <AddDialog
        show={addModalShow}
        statusList={props.statusList}
        setstatusList={props.setstatusList}
        onHide={() => {
          setAddModalShow(false);
          setSelectedItem({});
        }}
        statusId={props.statusId}
        setRefetchTable={props.setRefetchTable}
        selectedItem={selectedItem}
      />
    </div>
  );
};

export default FormTable;
